import React from "react";
import "./SettingsForm.css";
import GenderSelection from "./GenderSelection";
import BrandSelection from "./BrandSelection";

const SettingsForm = (
  {
    gender,
    changeGender,
    carSeatBrands,
    selectedCarSeatBrands,
    updateSelectedCarSeatBrands,
    clothingBrands,
    selectedClothingBrands,
    updateSelectedClothingBrands,
  }
) => {
  return(
    <div className="settings-container">
      <div className="container">

        <fieldset id="amazon-filters" className="row">
          <legend>Amazon Search filters</legend>
          <div className="">
            <GenderSelection gender={gender} changeGender={changeGender} />
          </div>
        </fieldset>

        <br/>

        <BrandSelection brands={carSeatBrands}
          selectedBrands={selectedCarSeatBrands}
          updateSelectedBrands={updateSelectedCarSeatBrands}
          title="Car Seat Brands"
        />

        <br/>

        <BrandSelection brands={clothingBrands}
          selectedBrands={selectedClothingBrands}
          updateSelectedBrands={updateSelectedClothingBrands}
          title="Clothing Brands"
        />
      </div>
    </div>
  );
};

SettingsForm.propTypes = {
  gender: React.PropTypes.string.isRequired,
  changeGender: React.PropTypes.func.isRequired,
  carSeatBrands: React.PropTypes.array.isRequired,
  selectedCarSeatBrands: React.PropTypes.object.isRequired,
  updateSelectedCarSeatBrands: React.PropTypes.func.isRequired,
  clothingBrands: React.PropTypes.array.isRequired,
  selectedClothingBrands: React.PropTypes.object.isRequired,
  updateSelectedClothingBrands: React.PropTypes.func.isRequired,
};

export default SettingsForm;



/** WEBPACK FOOTER **
 ** ./src/components/SettingsForm/SettingsForm.js
 **/